export default "__VITE_ASSET__Dp5LrE7S__"